import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ContactForm from "../components/ContactForm";
import {
  SakuraFlower,
  CherryBranchImg,
} from "../components/SakuraDecorations";

export default function KontaktPage() {
  const openingHours = [
    { day: "Mandag", hours: "09:00 - 18:00" },
    { day: "Tirsdag", hours: "09:00 - 18:00" },
    { day: "Onsdag", hours: "09:00 - 18:00" },
    { day: "Torsdag", hours: "09:00 - 18:00" },
    { day: "Fredag", hours: "09:00 - 18:00" },
    { day: "Lørdag", hours: "09:00 - 18:00" },
    { day: "Søndag", hours: "Lukket" },
  ];

  return (
    <>
      <Helmet>
        <title>Kontakt Kita Akupunktur i Risskov | Book Tid</title>
        <meta
          name="description"
          content="Kontakt Kita Akupunktur på Kantorparken 11 i Risskov nær Aarhus. Ring på 29 38 71 86 eller send en besked for tidsbestilling og spørgsmål."
        />
        <meta property="og:title" content="Kontakt Kita Akupunktur i Risskov | Book Tid" />
        <meta
          property="og:description"
          content="Kontakt Kita Akupunktur på Kantorparken 11 i Risskov nær Aarhus. Ring på 29 38 71 86 eller send en besked for tidsbestilling og spørgsmål."
        />
        <link rel="canonical" href="https://kita-akupunktur.dk/kontakt/" />
      </Helmet>

      {/* Page Header */}
      <section className="bg-gradient-to-b from-[#FFFAF7] via-[#FFE0CF]/30 to-[#FFFAF7] py-14 lg:py-20 border-b border-[#ffe0cf]/80 relative z-20 overflow-hidden">
        {/* Botanical Cherry Branch Accent from /design-elements/ (cherry-1.png) */}
        <div className="absolute -top-6 -right-6 w-56 sm:w-72 opacity-50 pointer-events-none z-10">
          <CherryBranchImg index={1} flip={true} className="w-full h-auto" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full glass-pill mb-3 text-xs font-semibold text-[#d74814]">
            <SakuraFlower className="w-3.5 h-3.5 text-[#d74814]" />
            <span>TIDSBESTILLING & KONTAKT • KITA AKUPUNKTUR</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#593427]">
            Kontakt mig i dag
          </h1>
          <p className="text-base sm:text-lg text-[#593427]/80 mt-3 max-w-2xl">
            Har du spørgsmål eller ønsker du tidsbestilling hos{" "}
            <Link to="/" className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#b3360b] hover:decoration-[#d74814] transition-colors">
              Kita Akupunktur
            </Link>
            ? Du er altid velkommen til at kontakte mig.
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 space-y-12">
        {/* Top: Info and Opening Hours first */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Klinikoplysninger */}
          <div className="glass-card p-8 rounded-3xl border border-[#ffe0cf] shadow-md space-y-6 relative overflow-hidden flex flex-col justify-between">
            <div className="absolute -bottom-8 -right-8 w-36 opacity-15 pointer-events-none">
              <CherryBranchImg index={5} className="w-full h-auto" />
            </div>

            <div>
              <div className="flex items-center justify-between pb-3 border-b border-[#ffe0cf] relative z-10 mb-6">
                <div>
                  <span className="text-xs uppercase tracking-wider font-semibold text-[#d74814]">
                    Klinikoplysninger
                  </span>
                  <h2 className="text-2xl font-serif font-bold text-[#593427] mt-0.5">
                    <Link to="/" className="hover:text-[#d74814] transition-colors">
                      Kita Akupunktur
                    </Link>
                  </h2>
                </div>
              </div>

              <div className="space-y-5 relative z-10">
                {/* Adresse */}
                <div className="flex items-start space-x-4 text-[#593427]">
                  <div className="w-10 h-10 rounded-2xl bg-[#ffe0cf] text-[#d74814] flex items-center justify-center shrink-0 mt-0.5 border border-[#ffe0cf]">
                    <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Adresse</p>
                    <p className="text-[#593427]/90">Kantorparken 11, 8240 Risskov</p>
                    <p className="text-xs text-[#593427]/70 mt-1 font-medium flex items-center">
                      <SakuraFlower className="w-3 h-3 mr-1 text-[#d74814]" />
                      Der kan parkeres gratis ude foran huset
                    </p>
                  </div>
                </div>

                {/* Telefon */}
                <div className="flex items-start space-x-4 text-[#593427]">
                  <div className="w-10 h-10 rounded-2xl bg-[#ffe0cf] text-[#d74814] flex items-center justify-center shrink-0 mt-0.5 border border-[#ffe0cf]">
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Telefon</p>
                    <a
                      href="tel:29387186"
                      className="text-[#d74814] font-serif font-bold text-lg hover:underline whitespace-nowrap"
                    >
                      (+45) 29 38 71 86
                    </a>
                    <p className="text-xs text-[#593427]/70 mt-0.5">Ring gerne for tidsbestilling eller spørgsmål</p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4 text-[#593427]">
                  <div className="w-10 h-10 rounded-2xl bg-[#ffe0cf] text-[#d74814] flex items-center justify-center shrink-0 mt-0.5 border border-[#ffe0cf]">
                    <i className="fa-solid fa-envelope" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Email</p>
                    <a
                      href="mailto:kontakt@kita-akupunktur.dk"
                      className="text-[#d74814] font-medium hover:underline whitespace-nowrap text-sm"
                    >
                      kontakt@kita-akupunktur.dk
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-[#ffe0cf] relative z-10 space-y-4">
              <div className="text-xs text-[#593427]/70 flex items-center justify-between">
                <span>CVR nr.: 43982303</span>
                <Link
                  to="/priser"
                  className="text-[#d74814] font-semibold underline decoration-[#ffe0cf] hover:text-[#593427]"
                >
                  RAB-registreret (Tilskud)
                </Link>
              </div>
              <div className="pt-1">
                <Link
                  to="/om-mig"
                  className="text-xs text-[#d74814] font-medium hover:underline flex items-center"
                >
                  <SakuraFlower className="w-3 h-3 mr-1 text-[#d74814]" />
                  Læs mere om behandler Mayumi Kita Thiele →
                </Link>
              </div>
              <a
                href="https://maps.app.goo.gl/BT5MeHuGxeQ2LBBW7"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center px-5 py-3 rounded-full bg-[#d74814] text-white font-semibold text-sm hover:bg-[#593427] transition-colors shadow-sm group"
              >
                <i className="fa-solid fa-map-location-dot mr-2 group-hover:scale-110 transition-transform text-[#ffe0cf]" aria-hidden="true" />
                <span>Find vej på Google Maps</span>
              </a>
            </div>
          </div>

          {/* Åbningstider */}
          <div className="glass-card p-8 rounded-3xl border border-[#ffe0cf] shadow-md flex flex-col justify-between">
            <div>
              <h3 className="text-xl font-serif font-bold text-[#593427] mb-4 flex items-center pb-3 border-b border-[#ffe0cf]">
                <i className="fa-regular fa-clock text-[#d74814] mr-2 text-base" aria-hidden="true" />
                Åbningstider
              </h3>
              <ul className="space-y-2.5 text-sm text-[#593427]/90">
                {openingHours.map((item, idx) => (
                  <li key={idx} className="flex justify-between items-center py-1 border-b border-[#ffe0cf]/50 last:border-0">
                    <span className="font-medium text-[#593427]">{item.day}</span>
                    <span className={item.hours === "Lukket" ? "text-stone-400 font-medium" : "text-[#593427] font-semibold"}>
                      {item.hours}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-6 p-3.5 rounded-xl bg-[#e1ef9f]/50 border border-[#e1ef9f] text-xs text-[#593427] text-center font-medium">
              Behandling foregår udelukkende efter aftale
            </div>
            <div className="mt-4 pt-3 border-t border-[#ffe0cf]/70 text-xs text-center">
              <Link
                to="/faq"
                className="text-[#593427] hover:text-[#d74814] font-medium underline decoration-[#ffe0cf]"
              >
                Har du spørgsmål før din første tid? Læs vores FAQ →
              </Link>
            </div>
          </div>
        </div>

        {/* Treatments navigation quick block */}
        <div className="p-6 rounded-3xl glass-sakura border border-[#ffe0cf] text-center space-y-4">
          <h3 className="text-lg font-serif font-semibold text-[#593427]">
            Hvilken behandling ønsker du at bestille tid til?
          </h3>
          <div className="flex flex-wrap justify-center gap-2 text-xs">
            <Link to="/japansk-akupunktur" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Japansk akupunktur
            </Link>
            <Link to="/stress" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Stress & nervesystem
            </Link>
            <Link to="/migraene" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Migræne & hovedpine
            </Link>
            <Link to="/ondt-i-kaeben" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Ondt i kæben
            </Link>
            <Link to="/spaendinger" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Nakke- & skulderspændinger
            </Link>
            <Link to="/ondt-i-ryggen" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Rygsmerter & lænd
            </Link>
            <Link to="/led-og-muskelsmerter" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Led- & muskelsmerter
            </Link>
            <Link to="/vaegtregulering" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Vægtregulering
            </Link>
            <Link to="/rygestop-behandling" className="px-3.5 py-1.5 rounded-full bg-white border border-[#ffe0cf] text-[#593427] hover:text-[#d74814] hover:border-[#d74814] transition-colors">
              Rygestop
            </Link>
            <Link to="/priser" className="px-3.5 py-1.5 rounded-full bg-[#d74814]/10 border border-[#d74814]/30 text-[#d74814] hover:bg-[#d74814] hover:text-white transition-colors font-medium">
              Se priser & tilskud →
            </Link>
          </div>
        </div>

        {/* Bottom: Contact Form under info & hours */}
        <div>
          <ContactForm />
        </div>
      </div>
    </>
  );
}